import { all } from 'redux-saga/effects';
import auditSagas from '@/audit/sagas';
import cohortSagas from '@/cohorts/sagas';
import collectionsSagas from '@/collections/sagas';
import configurationsSagas from '@/configurations/sagas';
import datasetsSagas from '@/datasets/sagas';
import layoutSagas from '@/layout/sagas';
import metricsSagas from '@/metrics/sagas';
import notificationsSagas from '@/notifications/sagas';
import requestsSagas from '@/requests/sagas';
import rolesSagas from '@/roles/sagas';
import searchSagas from '@/search/sagas';
import themesSagas from '@/themes/sagas';
import tokensApi from '@/tokens/sagas';
import usersSagas from '@/users/sagas';
import vocabulariesSagas from '@/vocabularies/sagas';
import websocketSagas from '@/websocket/sagas';
import workflowsSagas from '@/workflows/sagas';
import workspacesSagas from '@/workspaces/sagas';

export default function* rootSaga() {
  yield all([
    ...auditSagas,
    ...cohortSagas,
    ...collectionsSagas,
    ...configurationsSagas,
    ...datasetsSagas,
    ...layoutSagas,
    ...metricsSagas,
    ...notificationsSagas,
    ...requestsSagas,
    ...rolesSagas,
    ...searchSagas,
    ...themesSagas,
    ...tokensApi,
    ...usersSagas,
    ...vocabulariesSagas,
    ...websocketSagas,
    ...workflowsSagas,
    ...workspacesSagas,
  ]);
}
